import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileImageService {

  private imageSubject = new Subject<string>();

  constructor() {
  }

  shareData(data: string) {
    this.imageSubject.next(data);
  }

  getData(): Observable<any> {
    return this.imageSubject.asObservable();
  }
}
